function syncShapeImages(form, productJson, matchedVariant) {
  const colorIndex = productJson.options.findIndex(
    opt => typeof opt === "string" && opt.toLowerCase() === "color"
  );

  if (colorIndex === -1) return;

  const matchedColor = matchedVariant.options[colorIndex];

  const matchedVariantImages = productJson.variants
    .filter(v => v.options[colorIndex] === matchedColor && v.featured_image)
    .map(v => v.featured_image.src);

  const shapeImgs = form.querySelectorAll(".option-Shape .swatch-item img");

  shapeImgs.forEach((imgEl, i) => {
    if (matchedVariantImages[i]) {
      imgEl.src = matchedVariantImages[i];
    }
  });
}

function handleVariantChange(form) {
  const productJsonEl = form.querySelector("#custom-productJson");
  if (!productJsonEl) return;

  const productJson = JSON.parse(productJsonEl.textContent);

  const selects = form.querySelectorAll(".swatch-input:checked");
  if (!selects.length) return;

  const selectedOptions = [...selects].map(s => s.value);

  const matchedVariant = productJson.variants.find(v =>
    v.options.every((opt, index) => opt === selectedOptions[index])
  );

  if (!matchedVariant) return;

  syncShapeImages(form, productJson, matchedVariant);

  const card = form.closest(".product-card-varda");
  const pcsPerPageEl = card?.querySelector(".pcs-page");

  if (pcsPerPageEl && matchedVariant.variant_metafields?.pcs_per_page) {
    pcsPerPageEl.textContent = matchedVariant.variant_metafields.pcs_per_page;
  }

  const variantInput = form.querySelector(".product-variant-id");
  if (variantInput) {
    variantInput.value = matchedVariant.id;
  }

  selects.forEach((s, i) => {
    const optionName = productJson.options_name?.[i];
    if (!optionName) return;

    const legend = form.querySelector(`.legend--${optionName}`);
    if (legend) {
      const span = legend.querySelector(".value-selected");
      if (span) span.textContent = s.value;
    }

    const productImage = form
      .closest(".product-card__wrapper")
      ?.querySelector(".product-card__image--main img");

    if (productImage && matchedVariant.featured_image?.src) {
      const baseUrl = matchedVariant.featured_image.src.split("?")[0];
      productImage.src = baseUrl;
      productImage.srcset = `
        ${baseUrl}?width=70 70w,
        ${baseUrl}?width=140 140w,
        ${baseUrl}?width=450 450w,
        ${baseUrl}?width=710 710w,
        ${baseUrl}?width=900 900w
      `;
    }
  });

  const btn = form.querySelector("button[type='submit']");
  if (btn) {
    btn.disabled = !matchedVariant.available;
    const textEl = btn.querySelector(".product-card__atc-text");
    if (textEl) textEl.textContent = "Add to cart";
  }
}

document.addEventListener("change", (e) => {
  const input = e.target.closest(".swatch-input");
  if (!input) return;

  const form = input.closest(".custom-variant-picker form");
  if (!form) return;

  handleVariantChange(form);
});


document.addEventListener("collection:rerendered", () => {
  document
    .querySelectorAll(".custom-variant-picker form")
    .forEach(form => {
      handleVariantChange(form);
    });
});


document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".custom-variant-picker form")
    .forEach(form => {
      handleVariantChange(form);
    });
});
